import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useLeverageStore = defineStore("leverage", {
    state: () => {
        return {
            datas: null,
            loadings: false
        };
    },

    getters: {
        data: (state) => state.datas,
        loading: (state) => state.loadings,
    },

    actions: {
        get(symbol,id) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'trade/leverage',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    symbol: symbol,
                    dashboardid: id,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.datas = res.data.data.leverage
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        patch(data,id) {
            this.loadings = true;
            const config = {
                method: "patch",
                url: useRuntimeConfig().public.apiBase + 'trade/leverage',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
    },
});